<template>
<div class="reset-password login">
  <form class="card card--transparent" @submit="submit" lazy-validation>
    <h2>Reset Password</h2>
    <div v-if="error">{{error}}</div>
    <div class="input">
      <label>Email Address</label>
      <input
        v-model="email"
        type="email"
        aria-autocomplete="email"
        aria-label="Email"
        autocomplete="current-email"
        required
      />
    </div>
    <button type="submit" :disabled="this.loading" class="btn btn--outline full-width" style="margin-left: 0px">Reset Password</button>
    <router-link to='/'>Sign In</router-link>
  </form>
</div>
</template>

<script>
import AuthUser from "@/services/api/authUser";
import Nazgul from "@/services/nazgul";

export default {
  data() {
    return {
      email: "",
      loading: false,
      error: "",
      required: [v => !v && "Required"]
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      this.loading = true;
      this.error = "";
      Nazgul.report("password_request");
      AuthUser.resetPassword(this.email)
        .then(() =>
          alert(
            `An email to reset your password has been sent to ${this.email}`
          )
        )
        .catch(() => {
          this.error =
            "Server error. Our staff has been notified. Please try again later";
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less">
.reset-password {
  max-width: 500px;
  display: block;
  margin: 0 auto;
}
</style>
